import * as React from "react"

import Layout from "../components/Layout"

const ProjectAmenities = () => {
  return (
    <Layout>
      <h2>Amenities Around AMO ...</h2>

      <iframe
        title="Invest_Reasons"
        width="100%"
        height="600px"
        src="/Amenities.pdf#toolbar=0"
      ></iframe>
    </Layout>
  )
}

export default ProjectAmenities
